const TOKEN_KEY = 'jwtToken';
export const TOKEN_ID = 'idToken';
const EXPIRY_KEY = 'jwtTokenExpiry';
const EXPIRY_DURATION = 12 * 60 * 60 * 1000;


export const setJwtToken = (token, dispatch, id) => {
    if (!token) return;
    const expiry = Date.now() + EXPIRY_DURATION;
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(TOKEN_ID, id);
    localStorage.setItem(EXPIRY_KEY, expiry.toString());
};

export const getJwtToken = () => {
    const token = localStorage.getItem(TOKEN_KEY);
    const expiry = localStorage.getItem(EXPIRY_KEY);

    if (!token || !expiry) return null;

    const currentTime = Date.now();
    if (currentTime > parseInt(expiry, 10)) {
        clearJwtToken();
        return null;
    }

    return token;
};


export const clearJwtToken = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_ID);
    localStorage.removeItem(EXPIRY_KEY);
};
